export async function fetchMacroSeries(
  seriesId,
  { days = null, refresh = false, from = null, to = null, freq = null } = {},
) {
  const params = new URLSearchParams();
  if (days != null) params.set('days', String(days));
  if (refresh) params.set('refresh', '1');
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (freq) params.set('freq', freq);
  const qs = params.toString();
  const url = `/api/investing/macro/${encodeURIComponent(seriesId)}${qs ? `?${qs}` : ''}`;
  const response = await fetch(url);
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    const message = body?.error || `HTTP ${response.status}`;
    throw new Error(`${seriesId}: ${message}`);
  }
  return body;
}

export async function fetchMacroCatalog() {
  const response = await fetch('/api/investing/macro');
  if (!response.ok) {
    throw new Error(`Macro catalog HTTP ${response.status}`);
  }
  return response.json();
}
